import axios from 'axios'
const buildUrl = (path: string) => `${process.env.REACT_APP_API_BASE_URL ?? ''}${path}`

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface LdapAuthConfigDto {
  ldapAuthConfigId: string
  tenantId?: string | null
  name: string
  host: string
  port: number
  useSsl: boolean
  useTls: boolean
  baseDn: string
  bindDn?: string | null
  bindPassword?: string | null
  userFilter: string
  usernameAttr: string
  isActive: boolean
}

export interface LdapAuthConfigUpsertRequest {
  tenantId?: string | null
  name: string
  host: string
  port: number
  useSsl: boolean
  useTls: boolean
  baseDn: string
  bindDn?: string | null
  bindPassword?: string | null
  userFilter: string
  usernameAttr: string
  isActive: boolean
}

export interface LdapAuthConfigFilter {
  tenantId?: string
  isActive?: boolean
  page?: number
  pageSize?: number
}

export async function searchLdapAuthConfigs(filter: LdapAuthConfigFilter): Promise<PagedResultDto<LdapAuthConfigDto>> {
  const response = await axios.get<PagedResultDto<LdapAuthConfigDto>>(buildUrl('/api/v1/ldap-auth-configs'), {
    params: {
      tenantId: filter.tenantId,
      isActive: filter.isActive,
      page: filter.page ?? 1,
      pageSize: filter.pageSize ?? 20,
    },
  })
  return response.data
}

export async function createLdapAuthConfig(payload: LdapAuthConfigUpsertRequest): Promise<LdapAuthConfigDto> {
  const response = await axios.post<LdapAuthConfigDto>(buildUrl('/api/v1/ldap-auth-configs'), payload)
  return response.data
}

export async function updateLdapAuthConfig(id: string, payload: LdapAuthConfigUpsertRequest): Promise<LdapAuthConfigDto> {
  const response = await axios.post<LdapAuthConfigDto>(buildUrl(`/api/v1/ldap-auth-configs/${id}`), payload)
  return response.data
}
